require("core-js/es/object/values");
import Vue from "vue";
import App from "@/views/ExHome.vue";
import VuePortalDialog from "@bilibili/growup-portal-dialog";
// 样式引入
import "@bilibili/growup-portal-dialog/dist/portal-dialog.css";
Vue.use(VuePortalDialog, { blockMode: false });
import VueClipboard from "vue-clipboard2";
import "@/style/reset.scss";
import "@/style/exhome.scss";
const throttle = require("./throttle.js").default;
Vue.use(throttle);
Vue.use(VueClipboard);

Vue.config.productionTip = true;

Vue.config.errorHandler = function(err, _, info) {
  console.warn("Vue errorHandler: ", err, info);
};

new Vue({
  render: (h) => h(App)
}).$mount("#app");
